import React from 'react';
import PropTypes from 'prop-types';
import { PiCaretRight, PiChatTeardropDotsFill } from 'react-icons/pi';
import './styles.css';

const NaraAssistantLauncher = ({ onOpen }) => {
  return <button type="button" className="nara-launcher" onClick={() => onOpen('')} aria-label="Perguntar à Nara como fica seu dinheiro até a próxima renda">
    <span className="nara-launcher__identity" aria-hidden="true"><PiChatTeardropDotsFill /></span>
    <span className="nara-launcher__copy"><strong>Nara</strong><span>Como fica seu dinheiro até a próxima renda?</span></span>
    <PiCaretRight className="nara-launcher__chevron" aria-hidden="true" />
  </button>;
};

NaraAssistantLauncher.propTypes = { onOpen: PropTypes.func.isRequired };
export default NaraAssistantLauncher;
